import { render, staticRenderFns } from "./appAdminGroupIcon.vue?vue&type=template&id=74128d64&scoped=true"
import script from "./appAdminGroupIcon.vue?vue&type=script&lang=js"
export * from "./appAdminGroupIcon.vue?vue&type=script&lang=js"
import style0 from "./appAdminGroupIcon.vue?vue&type=style&index=0&id=74128d64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74128d64",
  null
  
)

export default component.exports